angular.module('ihestiaWidgets.policyOperations')
  .factory('customerVehiclesSvc', ['IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

      var CustomerVehiclesSvc = function() {
        IHestiaRestServiceAbstractDef.apply(this, arguments);

        this.resource = 'customers';
        this.businessArea = 'insurance';
        this.searchesPostfix = 'policies/communication/searches';
        this.pageStyle = true;
        this.sortBy = '';
      };

      return new CustomerVehiclesSvc();
    }]);